<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            >
            <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-radio-group v-model="form.estimator" column>
                    <v-radio v-for="(person, index) in estimators" :key="index" :value="person.id" :label="person.name"></v-radio>
                </v-radio-group>
                <v-list tile flat class="pt-0">
                    <v-list-item>
                        <v-list-item-content>
                            <v-datetime-picker label="Select a meeting Date/Time" v-model="form.datetime" date-format="MM/dd/yyyy" time-format="hh:mm a"> </v-datetime-picker>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click.prevent="goBack">Close</v-btn>
                <v-btn color="blue darken-1" text @click="submit">Save</v-btn>
            </v-card-actions>            
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

export default {
    props: ['id'],
    data () {
        return {
            form: {
                estimator: null,
                datetime: null,
                lead: null
            },
            pageTitle: ''
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.form.lead = this.id
        if(this.id) {
            axios.get('data/leads/get?id=' + this.id)
                .then((response) => {
                    if(response.data.estimator.id.length == 0) response.data.estimator.id = null
                    else this.form.estimator = response.data.estimator.id

                    if(response.data.schedule.length == 0) response.data.schedule = null
                    else this.form.datetime = new Date(response.data.schedule)
                })
        }
    },
    computed: {
        ...mapGetters({
            estimators: 'data/estimators'
        }),
    },
    methods: {
        ...mapActions({
            scheduleLead: 'data/scheduleEstimator'
        }),
        submit() {
            this.loading = true
            this.scheduleLead(this.form).then(() => {
                this.loading = false
                this.$router.go(-1)
                this.$store.commit('SET_SNACKTYPE', 'green')
                this.$store.commit('SET_SNACK', 'Successfully scheduled this lead!')
            }).catch(() => {
                this.loading = false
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Failed to schedule this! Please try again.')
            })
        },
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>